/* eslint-disable jsx-a11y/anchor-has-content */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';
import { t } from 'utils/translates';

import {
  changeFieldReasonId,
  changeFieldReasonComment,
  selectFieldReasonId,
  selectFieldReasonComment,
  sendRequest,
  selectRequestState
} from 'mt-react-common/modules/tasks/common/reducers/execDisputeForm';
import { getValueFromRefDataModules } from 'mt-react-common/modules/main/reducers/static/states/referenceLists/reducer';

import OpacityPreLoader from '../../../Common/PreLoaders/OpacityPreLoader';
import InfoMaterialContent from '../../../InfoMaterials/InfoMaterialContent';
import DefaultSelect from '../../../Common/Inputs/DefaultSelect';

// eslint-disable-next-line react/prefer-stateless-function
class TasksExecDisputeForm extends Component {
  componentDidUpdate(prevProp) {
    if (
      prevProp.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.closeAllTabs();
    }
  }
  render() {
    const hasError = fieldErrors => fieldErrors.length > 0;
    const errorDesc = fieldErrors => {
      if (fieldErrors.length > 0) {
        return (
          <React.Fragment>
            <small className="help-block m-b-5">
              <i className="fa fa-exclamation-triangle" />{' '}
              {fieldErrors[0].message}
            </small>
          </React.Fragment>
        );
      }
      return null;
    };
    const disputeConfirmId = `disputeConfirm${this.props.exec.id}`;
    return (
      <React.Fragment>
        <div
          aria-labelledby="myModalLabel"
          className="modal fade"
          role="dialog"
          tabIndex="-1"
          id={disputeConfirmId}
        >
          <div className="modal-dialog modal-gray modal-sm">
            <div className="modal-content">
              <div className="modal-header text-center">
                <a
                  aria-label="Close"
                  className="close close-black"
                  data-dismiss="modal"
                  href=""
                />
                <i className="fa fa-exclamation-triangle modal-icon" />
                <h4 className="modal-title">
                  <strong>{t('Подтверждение')}</strong>
                </h4>
              </div>
              <div className="modal-body text-center">
                {t(
                  'В случае решения не в вашу пользу вы можете получить штрафные баллы к вашему рейтингу. Вы действительно хотите создать обращение в арбитраж?'
                )}
              </div>
              <div className="modal-footer">
                <a
                  className="btn btn-muted"
                  data-dismiss="modal"
                  href=""
                  type="button"
                >
                  {t('Отмена')}
                </a>
                <a
                  className="btn btn-danger"
                  data-dismiss="modal"
                  href=""
                  type="button"
                  onClick={() => this.props.sendRequest()}
                >
                  {t('Создать обращение')}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-pane active">
          <div className="panel-footer">
            {this.props.requestState.hasInProgress ? (
              <OpacityPreLoader />
            ) : null}
            <div className="alert alert-danger text-center m-b-15" role="alert">
              <InfoMaterialContent id={'exec_dispute'} />
            </div>
            <form>
              <div
                className={`form-group ${
                  hasError(this.props.fieldReasonId.errors) ? 'has-error' : ''
                }`}
              >
                <label className="control-label" htmlFor="language">
                  {t('Причина обращения')}
                </label>
                <DefaultSelect
                  selectArrItems={this.props.tasksExecDisputesReasons.map(
                    item => {
                      if (item.visible === 1) {
                        return {
                          value: item.value,
                          title: item.title
                        };
                      }
                      return null;
                    }
                  )}
                  selectTitleNullValue={null}
                  placeholder={t('Выберите причину обращения')}
                  value={this.props.fieldReasonId.value}
                  handleChangeValue={value => {
                    this.props.changeFieldReasonId(value);
                  }}
                />
                {errorDesc(this.props.fieldReasonId.errors)}
              </div>
              {this.props.fieldReasonId.value === '1' ? (
                <div
                  className={`form-group ${
                    hasError(this.props.fieldReasonComment.errors)
                      ? 'has-error'
                      : ''
                  }`}
                >
                  <textarea
                    className="form-control"
                    name="arbitration"
                    placeholder={t('Введите причину обращения в арбитраж')}
                    rows="2"
                    value={this.props.fieldReasonComment.value}
                    onChange={e => {
                      this.props.changeFieldReasonComment(e.target.value);
                    }}
                  />
                  {errorDesc(this.props.fieldReasonComment.errors)}
                </div>
              ) : null}
              <div className="btn-toolbar">
                <a
                  className="btn btn-danger"
                  data-toggle="modal"
                  type="button"
                  href={`#${disputeConfirmId}`}
                >
                  {t('Отправить обращение в арбитраж')}
                </a>
              </div>
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TasksExecDisputeForm.propTypes = {
  // IN
  closeAllTabs: PropTypes.func.isRequired,
  tasksExecDisputesReasons: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,
  fieldReasonId: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  fieldReasonComment: PropTypes.shape({
    field: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  changeFieldReasonId: PropTypes.func.isRequired,
  changeFieldReasonComment: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.formReduceName),
  fieldReasonId: selectFieldReasonId(state, props.formReduceName),
  fieldReasonComment: selectFieldReasonComment(state, props.formReduceName),
  tasksExecDisputesReasons: getValueFromRefDataModules(
    state,
    'tasks.tasksExecDisputesReasons'
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldReasonId: value =>
    dispatch(changeFieldReasonId(props.formReduceName, value)),
  changeFieldReasonComment: value =>
    dispatch(changeFieldReasonComment(props.formReduceName, value)),
  sendRequest: () => dispatch(sendRequest(props.formReduceName, props.exec.id))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksExecDisputeForm)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecDisputeForm/TasksExecDisputeForm.js